import { Link, NavLink, useNavigate } from 'react-router-dom';
import { setAuthToken } from '../services/api';
import { useState, useEffect } from 'react';
import logoAsset from "../assets/images/springuplabs-logo.png";
import lockupAsset from "../assets/images/botroi-lockup6.png";
import "./Header.css";
function Header() {
  const [user, setUser] = useState(() => {
    const token = localStorage.getItem('jwt');
    if (!token) return null;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return { email: payload.email, name: payload.name || payload.email };
    } catch (e) {
      return null;
    }
  });
  const navigate = useNavigate();

  useEffect(() => {
    const syncUser = () => {
      const token = localStorage.getItem('jwt');
      if (!token) {
        setUser(null);
        return;
      }

      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setUser({ email: payload.email, name: payload.name || payload.email });
      } catch (e) {
        setUser(null);
      }
    };

    syncUser();
    window.addEventListener('auth:changed', syncUser);
    return () => window.removeEventListener('auth:changed', syncUser);
  }, []);

  function initialsOf(email) {
  const base = email.split("@")[0] ?? "";
  const parts = base.split(/[.\-_]/).filter(Boolean);
  const first = parts[0]?.[0] ?? "";
  const second = parts[1]?.[0] ?? parts[0]?.[1] ?? "";
  return (first + second).toUpperCase();
}

  function logout() {
    setAuthToken(null);
    setUser(null);
    navigate('/');
  }

  return (
   <header className="sp-header">
    <div className="sp-header__inner">
       {/* Brand */}
        <Link to="/" className="sp-brand" aria-label="SpringUpLabs Germany home">
          <img
            src={logoAsset}
            alt="SpringUpLabs Germany logo"
            className="sp-brand__logo"
            width={200}
            height={38}
          />
        </Link>   

      {/* Product lockup */}
        <div className="sp-titles">
          <img
            src={lockupAsset}
            alt="BOT ROI & Implementation Advisor — Intake to ROI to Implementation Blueprint"
            className="sp-lockup"
            width={1200}
            height={175}
          />
        </div>

      {/* Auth / nav */}
      <nav className="sp-nav">
        {user ? (
          <div className="sp-userchip">
            <span className="sp-userchip__avatar" aria-hidden="true">
              {initialsOf(user.email)}
            </span>
            <span className="sp-userchip__email" title={user.email}>
              {user.email}
            </span>
            <button
              type="button"
              className="sp-btn sp-btn--logout"
              onClick={logout}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
              <span className="sp-btn__label">Logout</span>
            </button>
          </div>
        ) : (
          <div className="sp-signin">
            <span className="sp-signin__lock" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
            </span>
            <span className="sp-signin__text">Secure sign-in required</span>
          </div>
        )}
      </nav>
    </div>
  </header>
  );
}

export default Header;
